import React from 'react'

import SecondaryLoginButton from 'ui-component-library/components/Login/SecondaryLoginButton'

type Props = {
  className?: string
  children: React.ReactNode
}

function LoginButton({ className, children }: Props) {
  return (
    <SecondaryLoginButton className={className} variant='primaryBlue'>
      {children}
    </SecondaryLoginButton>
  )
}

export default LoginButton
